import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './privacy.html';

@Component({
  controllerAs: 'privacy',
  template
})

export default class Privacy {
  static $inject = [
    
    '$state',
    '$ngRedux',
    '$scope',
    'authService',
    '$window',
    '$stateParams',
    'APP'
  ];

  constructor( $state,$ngRedux, $scope, $auth, $window, APP, $stateParams) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = $auth;
    this.$state = $state;
    this.APP = APP;
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/static/privacy.js